import Vue from 'vue';

Vue.component('vuetable_restriction', () =>
    import(/* webpackChunkName: 'restriction' */ './restriction.vue'),
);

Vue.component('create-restriction', () =>
    import(/* webpackChunkName: 'create_restriction' */ './create_restriction.vue'),
);

Vue.component('restriction-details', () =>
    import(/* webpackChunkName: 'restriction_details' */ './restriction-details.vue'),
);
